"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpQueryFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const QueryFieldKey_1 = __importDefault(require("../QueryFieldKey"));
exports.OpQueryFields = {
    [QueryFieldKey_1.default.OP_STARTFROM]: {
        key: QueryFieldKey_1.default.OP_STARTFROM,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('start-from'),
    },
    [QueryFieldKey_1.default.OP_COMPLETEBY]: {
        key: QueryFieldKey_1.default.OP_COMPLETEBY,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('complete-by'),
    },
    [QueryFieldKey_1.default.OP_ACTUALSTART]: {
        key: QueryFieldKey_1.default.OP_ACTUALSTART,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('actual-start'),
    },
    [QueryFieldKey_1.default.OP_ACTUALCOMPLETE]: {
        key: QueryFieldKey_1.default.OP_ACTUALCOMPLETE,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('actual-complete'),
    },
    [QueryFieldKey_1.default.OP_STATUS]: {
        key: QueryFieldKey_1.default.OP_STATUS,
        fieldType: StaticFieldType_1.default.OP_STATUS,
        label: () => lib_i18n_1.default.t('op-status'),
    },
    [QueryFieldKey_1.default.OP_HASISSUES]: {
        key: QueryFieldKey_1.default.OP_HASISSUES,
        fieldType: StaticFieldType_1.default.OP_HASISSUES,
        label: () => lib_i18n_1.default.t('issues'),
    },
    [QueryFieldKey_1.default.OP_SCORE]: {
        key: QueryFieldKey_1.default.OP_SCORE,
        fieldType: BasicFieldType_1.default.OP_SCORE,
        label: () => lib_i18n_1.default.t('score'),
    },
    [QueryFieldKey_1.default.OP_GRADE]: {
        key: QueryFieldKey_1.default.OP_GRADE,
        fieldType: StaticFieldType_1.default.OP_GRADE,
        label: () => lib_i18n_1.default.t('grade'),
    },
    [QueryFieldKey_1.default.OP_PASSSTATUS]: {
        key: QueryFieldKey_1.default.OP_PASSSTATUS,
        fieldType: StaticFieldType_1.default.OP_PASSSTATUS,
        label: () => lib_i18n_1.default.t('pass-status'),
    },
    [QueryFieldKey_1.default.OP_QUESTION]: {
        key: QueryFieldKey_1.default.OP_QUESTION,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('question'),
    },
    [QueryFieldKey_1.default.OP_ANSWER]: {
        key: QueryFieldKey_1.default.OP_ANSWER,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('answer'),
    },
};
exports.default = exports.OpQueryFields;
